import React, { useRef } from 'react'
import clsx from 'clsx'
import Slider, { Settings } from 'react-slick'
import 'slick-carousel/slick/slick.css'
import { Image } from '@/components/atoms/Image/Image'
import { SliderButtonsTranslation } from '@/helpers/getSliderButtonsTranslation'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'
import { Slides } from './types'
import * as styles from './ContentSlider.module.css'

const SLIDER_SETTINGS = {
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 20000,
  speed: 500
}

export function ContentSlider({ content }: Slides<Settings>) {
  const sliderRef = useRef<Slider>(null)
  const gotoNext = () => sliderRef?.current?.slickNext()
  const gotoPrev = () => sliderRef?.current?.slickPrev()

  const renderArrows = () => (
    <div>
      <button
        type="button"
        className={clsx(styles.leftArrowIcon, 'p-0 absolute left-0 top-14 tablet:top-96 z-10 text-text-dark-900')}
        onClick={gotoPrev}
        aria-label={SliderButtonsTranslation.previous}
      >
        <i className="block tablet:hidden fa fa-chevron-left text-xl" aria-hidden="true" />
      </button>
      <button
        type="button"
        className={clsx(styles.rightArrowIcon, 'p-0 absolute right-0 top-14 tablet:top-96 z-10 text-text-dark-900')}
        onClick={gotoNext}
        aria-label={SliderButtonsTranslation.next}
      >
        <i className="block tablet:hidden fa fa-chevron-right text-xl" aria-hidden="true" />
      </button>
    </div>
  )

  return (
    <div className="relative">
      {renderArrows()}
      <Slider {...SLIDER_SETTINGS} ref={sliderRef}>
        {content.map((slide) => (
          <div key={slide._uid} className={clsx(styles.wrapper, 'tablet:px-20')}>
            <Image fixed data={slide.icon} width={100} height={50} />
            <Paragraph className="text-bodyM tablet:text-bodyL text-text-dark-900 mb-16 tablet:mb-24 laptop:px-0 max-w-44 mx-auto">
              {slide.testimonial}
            </Paragraph>
            <p className="block font-poppins text-headingS-mobile font-bold text-text-dark-900 mb-16 netbook:text-headingS">
              {slide.author}
            </p>
            <p className="text-bodyL text-text-dark-900">{slide.position}</p>
          </div>
        ))}
      </Slider>
    </div>
  )
}
